"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletPOINodeInterface = void 0;
const engine_1 = require("@railgun-community/engine");
const poi_node_request_1 = require("./poi-node-request");
const shared_models_1 = require("@railgun-community/shared-models");
const poi_required_1 = require("./poi-required");
class WalletPOINodeInterface extends engine_1.POINodeInterface {
    poiNodeRequest;
    constructor(poiNodeURLs) {
        super();
        this.poiNodeRequest = new poi_node_request_1.POINodeRequest(poiNodeURLs);
    }
    static poiStatusToTXOPOIStatus = (poiStatus) => {
        switch (poiStatus) {
            case shared_models_1.POIStatus.Valid:
                return engine_1.TXOPOIListStatus.Valid;
            case shared_models_1.POIStatus.ShieldBlocked:
                return engine_1.TXOPOIListStatus.ShieldBlocked;
            case shared_models_1.POIStatus.ProofSubmitted:
                return engine_1.TXOPOIListStatus.ProofSubmitted;
            case shared_models_1.POIStatus.Missing:
                return engine_1.TXOPOIListStatus.Missing;
        }
    };
    static getPOISettings(chain) {
        const network = (0, shared_models_1.networkForChain)(chain);
        if (!network) {
            throw new Error(`No network found`);
        }
        const networkPOISettings = network.poi;
        if (!networkPOISettings) {
            throw new Error(`No POI settings found`);
        }
        return networkPOISettings;
    }
    // eslint-disable-next-line class-methods-use-this
    isActive(chain) {
        return WalletPOINodeInterface.getPOISettings(chain) != null;
    }
    // eslint-disable-next-line class-methods-use-this
    async isRequired(chain) {
        const network = (0, shared_models_1.networkForChain)(chain);
        if (!network) {
            throw new Error(`No network for chain ${chain.type}:${chain.id}`);
        }
        return poi_required_1.POIRequired.isRequiredForNetwork(network.name);
    }
    async getPOIsPerList(txidVersion, chain, listKeys, blindedCommitmentDatas) {
        const poisPerList = await this.poiNodeRequest.getPOIsPerList(txidVersion, chain, listKeys, blindedCommitmentDatas);
        const poisPerListConverted = {};
        for (const blindedCommitment of Object.keys(poisPerList)) {
            poisPerListConverted[blindedCommitment] = {};
            for (const listKey of Object.keys(poisPerList[blindedCommitment])) {
                const poiStatus = poisPerList[blindedCommitment][listKey];
                poisPerListConverted[blindedCommitment][listKey] =
                    WalletPOINodeInterface.poiStatusToTXOPOIStatus(poiStatus);
            }
        }
        return poisPerListConverted;
    }
    async getPOIMerkleProofs(txidVersion, chain, listKey, blindedCommitments) {
        return this.poiNodeRequest.getPOIMerkleProofs(txidVersion, chain, listKey, blindedCommitments);
    }
    async validatePOIMerkleroots(txidVersion, chain, listKey, poiMerkleroots) {
        return this.poiNodeRequest.validatePOIMerkleroots(txidVersion, chain, listKey, poiMerkleroots);
    }
    async submitPOI(txidVersion, chain, listKey, snarkProof, poiMerkleroots, txidMerkleroot, txidMerklerootIndex, blindedCommitmentsOut, railgunTxidIfHasUnshield) {
        const transactProofData = {
            snarkProof,
            poiMerkleroots,
            txidMerkleroot,
            txidMerklerootIndex,
            blindedCommitmentsOut,
            railgunTxidIfHasUnshield,
        };
        return this.poiNodeRequest.submitPOI(txidVersion, chain, listKey, transactProofData);
    }
    async submitLegacyTransactProofs(txidVersion, chain, listKeys, legacyTransactProofDatas) {
        return this.poiNodeRequest.submitLegacyTransactProofs(txidVersion, chain, listKeys, legacyTransactProofDatas);
    }
}
exports.WalletPOINodeInterface = WalletPOINodeInterface;
